import NativeModulesProxy from '../NativeModulesProxy';
export default NativeModulesProxy.ExpoModulesCoreErrorManager;